import { TranslationFn } from '@/common/hooks/useI18n'
import { N_BEDROOMS } from '@/modules/property/translation'

interface GetRoomDisplayNameParams {
  t: TranslationFn
  room?: RentAPerfect.Room | null
}

const getRoomDisplayName = ({ t, room }: GetRoomDisplayNameParams) =>
  room?.roomName ??
  (room?.RoomInfo
    ? [
        room.RoomInfo.houseNumber,
        t(N_BEDROOMS, { n: room.RoomInfo.roomNumber }),
      ]
        .filter(Boolean)
        .join(' - ')
    : 'Untitled')

export default getRoomDisplayName
